import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { useUserIdVerificationViewModel } from 'FrontRoyalAngular/useUserIdVerificationViewModel';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { faIdCard } from '@fortawesome/pro-regular-svg-icons/faIdCard';
import { BasicMobileBox } from '../../BasicMobileBox';
import { ImportantCtaBox } from '../../ImportantCtaBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

function IdentityVerificationBoxComponent({ mobile }: { mobile?: boolean }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'identityVerificationBox' });
    const UserIdVerificationViewModel = useUserIdVerificationViewModel();

    const userIdVerificationViewModel = useMemo(() => new UserIdVerificationViewModel(), [UserIdVerificationViewModel]);

    const buttons = useMemo<ButtonConfig[]>(
        () => [
            {
                id: 'button_verify_identity',
                text: t('buttonVerifyIdentity'),
                onPress: () => {
                    userIdVerificationViewModel.launchVerificationModal();
                },
            },
        ],
        [t, userIdVerificationViewModel],
    );
    return mobile ? (
        <IdentityVerificationBoxMobilePresentation ctaButton={buttons[0]} />
    ) : (
        <IdentityVerificationBoxPresentation ctaButton={buttons[0]} />
    );
}

function IdentityVerificationBoxPresentation({ ctaButton }: { ctaButton: ButtonConfig }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'identityVerificationBox' });
    return (
        <ImportantCtaBox
            boxKey={SidebarBoxKey.identity_verification}
            headerSubtitle={t('subtitle')}
            headerTitle={t('title')}
            ctaText={ctaButton.text}
            onPressCta={ctaButton.onPress}
            iconCircle
            icon={<FontAwesomeIcon icon={faIdCard} />}
        >
            {t('content')}
        </ImportantCtaBox>
    );
}

function IdentityVerificationBoxMobilePresentation({ ctaButton }: { ctaButton: ButtonConfig }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'identityVerificationBox' });
    return (
        <BasicMobileBox
            boxKey={SidebarBoxKey.identity_verification}
            heading={t('mobileTitle')}
            ctaText={t('buttonNextSteps')}
            expandedContent={<IdentityVerificationBoxPresentation ctaButton={ctaButton} />}
        />
    );
}

export const IdentityVerificationBox = memo(
    IdentityVerificationBoxComponent,
) as typeof IdentityVerificationBoxComponent;
